<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <button class="btn btn-primary mb-2" @click="addNewItem">ساخت بنر جدید</button>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>ترتیب</th>
                    <th>توضیحات</th>
                    <th>نمایش از</th>
                    <th>نمایش تا</th>
                    <th>وضعیت</th>
                    <th>قوانین نمایش</th>
                    <th>لینک اکشن</th>
                    <th>تصویر</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="banner in banners" :key="banner._id">
                    <td>{{ banner.title }}</td>
                    <td>{{ banner.order }}</td>
                    <td>{{ banner.description }}</td>
                    <td>
                      {{
                        banner.startFrom
                          ? `${new Date(banner.startFrom).toLocaleDateString('fa-IR')} - ${new Date(
                              banner.startFrom,
                            ).toLocaleTimeString('fa-IR')}`
                          : '-'
                      }}
                    </td>
                    <td>
                      {{
                        banner.endIn
                          ? `${new Date(banner.endIn).toLocaleDateString('fa-IR')} - ${new Date(
                              banner.endIn,
                            ).toLocaleTimeString('fa-IR')}`
                          : '-'
                      }}
                    </td>
                    <td>{{ banner.isActive ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      {{ banner.isShowRulesActive ? getRulesString(banner.showRules) : 'نمایش به همه' }}
                    </td>

                    <td>
                      <a v-if="banner.actionUrl != null" :href="banner.actionUrl">لینک</a>
                      <span v-else>ندارد</span>
                    </td>
                    <td>
                      <a :href="banner.imageUrl">مشاهده</a>
                    </td>
                    <td>
                      <button class="btn btn-secondary" @click="editItem(banner)">ویرایش</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="ADDEDITMODAL" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">بنر</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.title" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>عنوان بنر</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="order" type="text" v-model="modal.order" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>ترتیب بنر</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.description" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>توضیحات بنر</label>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group row d-flex align-items-center mb-5">
                    <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">شروع نمایش از</label>
                    <date-picker
                      name="startDate"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="modal.startFrom"
                    ></date-picker>
                    <div class="col-lg-6"></div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group row d-flex align-items-center mb-5">
                    <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نمایش تا</label>
                    <date-picker
                      name="startDate"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DDTHH:mm:SSZ"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="modal.endIn"
                    ></date-picker>
                    <div class="col-lg-6"></div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <label>فعال باشد؟</label>
                      <input class="" name="" type="checkbox" v-model="modal.isActive" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت قوانین نمایش</label>
                  <div class="col-lg-6">
                    <select name="isShowRulesActive" class="form-control" id v-model="modal.isShowRulesActive">
                      <option :value="true">فعال</option>
                      <option :value="false">غیر فعال</option>
                    </select>
                  </div>
                </div>

                <div v-if="modal.isShowRulesActive" class="col-lg-12">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"> قوانین نمایش</label>
                  <div class="col-lg-6">
                    <select name="showRules" class="form-control" id v-model="modal.showRules" multiple>
                      <option disabled value="">انتخاب کنید</option>
                      <option v-for="rule in rules" :key="rule._id" :value="rule._id">{{ rule.title }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class=" mt-3 ">
                      <label class="col-4">نوع اکشن</label>
                      <select class="col-8 " name="" id="" v-model="modal.type">
                        <option selected value="None">ندارد</option>
                        <option value="Browse">باز شدن مرورگر</option>
                        <option value="League">باز شدن لیگ</option>
                        <option value="Shop">باز شدن فروشگاه</option>
                        <option value="Multi">بازی دو نفره</option>
                        <option value="Premier">لیگ پریمیر</option>
                        <option value="Spin">باز شدن اسپینر</option>
                        <option value="Reward">جایزه</option>
                        <option value="VerifyAccount">تایید حساب</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="modal.type == 'Browse'" class="col-lg-12 mt-2">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.actionUrl" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>لینک اکشن</label>
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    modal.type == 'League' || modal.type == 'Shop' || modal.type == 'Multi' || modal.type == 'Reward'
                  "
                  class="col-lg-12 mt-2"
                >
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.actionId" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>آیدی آیتم را وارد کنید</label>
                    </div>
                  </div>
                </div>

                <div v-if="modal.type == 'Shop'" class="col-lg-12 mt-2">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" v-model="modal.actionCat" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>دسته بندی آیتم را وارد کنید</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 mt-2">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="col-12">
                      <label class="col-4" for="">{{ modal.imageUrl ? 'انتخاب تصویر جدید' : 'تصویر' }}</label>
                      <input
                        accept="image/*"
                        id="image"
                        name="image"
                        @change="fileSelectet"
                        class="col-8"
                        type="file"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button v-if="modal._id" @click="deleteBanner" type="button" class="btn btn-danger ml-4">
                حذف
              </button>
              <button type="submit" class="btn btn-primary ml-auto" @click="changeItem">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bannerService from '../../../../services/bannerService';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import moment from 'moment';
import PermissionService from '../../../../services/UsersRulePermissions';

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  name: 'league',
  data() {
    return {
      banners: [],
      rules: [],
      modal: {
        isShowRulesActive: false,
      },
      file: null,
    };
  },
  created() {
    this.getBanners({});
    this.getRules();
  },
  methods: {
    async getBanners(conditions) {
      try {
        const data = await bannerService.getBanners(conditions);
        this.banners = data;
      } catch (err) {
        console.log(err);
      }
    },

    addNewItem() {
      this.modal = {};
      this.file = null;
      window.$('#ADDEDITMODAL').modal('show');
    },
    editItem(item) {
      this.modal = { ...item };
      this.file = null;
      window.$('#ADDEDITMODAL').modal('show');
    },
    async getRules() {
      try {
        const resData = await PermissionService.getRules({});
        this.rules = resData;
      } catch (err) {
        console.log(err);
      }
    },
    getRulesString(rules) {
      let string = '';
      for (let i = 0; i < rules.length; i++) {
        const rule = rules[i];
        string += `${rule.title}`;
        if (i != rules.length - 1) {
          string += ' | ';
        }
      }
      return string;
    },
    async changeItem() {
      try {
        const body = {
          title: this.modal.title,
          order: this.modal.order ?? 0,
          description: this.modal.description,
          isActive: this.modal.isActive ?? false,
          isShowRulesActive: this.modal.isShowRulesActive,
          showRules: this.modal.showRules,
        };

        const data = this.obj2FormData(body);

        if (this.file) {
          data.append('file', this.file);
        }

        if (this.modal.startFrom) {
          data.append('startFrom', moment(this.modal.startFrom, 'YYYY-MM-DDTHH:mm:SSZ').toISOString());
        }

        if (this.modal.endIn) {
          data.append('endIn', moment(this.modal.endIn, 'YYYY-MM-DDTHH:mm:SSZ').toISOString());
        }

        if (this.modal.actionUrl) {
          data.append('actionUrl', this.modal.actionUrl);
        }
        if (this.modal.type) {
          data.append('type', this.modal.type);
        }
        if (this.modal.actionCat) {
          data.append('actionCat', this.modal.actionCat);
        }
        if (this.modal.actionId) {
          data.append('actionId', this.modal.actionId);
        }

        if (this.modal._id) {
          data.append('id', this.modal._id);
          await bannerService.updateBanner(data);
          // edit
          window.notif({ isError: false, mssg: `بنر بروزرسانی شد` });
          window.$('#ADDEDITMODAL').modal('hide');
          this.getBanners({});
        } else {
          if (this.file == null) {
            window.notif({ isError: true, mssg: `تصویر را انتخاب نکرده اید` });

            return;
          }
          await bannerService.creatBanner(data);
          window.notif({ isError: false, mssg: `بنر ایجاد شد` });
          window.$('#ADDEDITMODAL').modal('hide');
          this.getBanners({});
        }
      } catch (error) {
        window.notif({ isError: true, mssg: `مشکلی پیش آمده بعدا تلاش کنید` });
      }
    },

    obj2FormData(obj, formData = new FormData()) {
      const data = formData;
      const createFormData = function(obj, subKeyStr = '') {
        for (let i in obj) {
          let value = obj[i];
          let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i;
          if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            data.append(subKeyStrTrans, value);
          } else if (typeof value === 'object') {
            createFormData(value, subKeyStrTrans);
          }
        }
      };
      createFormData(obj);
      return data;
    },

    async deleteBanner() {
      try {
        await bannerService.deleteBanner(this.modal._id);
        window.notif({ isError: false, mssg: `بنر حذف شد` });
        window.$('#ADDEDITMODAL').modal('hide');
        this.getBanners({});
      } catch (error) {
        window.notif({ isError: true, mssg: `مشکلی پیش آمده بعدا تلاش کنید` });
      }
    },

    fileSelectet(e) {
      this.file = e.target.files[0];
    },
  },
};
</script>
